import React from "react";
// import axios from "axios";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";

import { ItemTypes } from "../ItemTypes";

import { useDrop } from "react-dnd";

export default function Todos(props) {
  // console.log(props);
  const { classes, list, who, dropStateHandler } = props;

  const whereAmI = who.toLowerCase();
  // console.log(status);

  const dropEventHandler = data => {
    data.status = whereAmI;
    // const url = `http://localhost:5000/changestatus`;

    const object = {
      id: data._id,
      status: data.status
    };
    dropStateHandler({ response: "response", body: object });

    // axios
    //   .put(url, object)
    //   .then(response => {
    //     // console.log({ response: response.data, body: object });
    //     dropStateHandler({ response: response.data, body: object });
    //   })
    //   .catch(err => console.log(err));
  };

  const [{ isOver }, drop] = useDrop({
    accept: ItemTypes.LIST,
    drop: item => dropEventHandler(item.data),
    collect: monitor => ({
      isOver: !!monitor.isOver()
    })
  });

  return (
    <div
      ref={drop}
      style={{
        position: "relative",
        width: "100%",
        height: "100%"
      }}
    >
      <Paper className={classes}>
        {isOver && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              height: "100%",
              width: "100%",
              zIndex: 1,
              opacity: 0.2,
              backgroundColor: "blue"
            }}
          />
        )}
        <Typography variant="h4" component="h4">
          {who}
        </Typography>
        <Divider variant="middle" />
        <Typography variant="h5" component="h4">
          {list}
        </Typography>
      </Paper>
    </div>
  );
}
